import React from 'react'
import { Icon } from '@pff-consumer/web-ui/components/icon/icon'
import { SVGGroup } from '@pff-consumer/utils'
import { ButtonProps } from './button.props'
import { useStyles } from './button.styles'

// TODO - USE TWEED

export const Button = (props: ButtonProps) => {
  const {
    type,
    children,
    onClick,
    iconName,
    iconWidth,
    iconHeight,
    disabled = false,
    text = '',
    className,
    size = 'lg',
    ...other
  } = props
  const styles = useStyles(props)

  const isLargeBtn = size === 'lg'
  const clsName = disabled
    ? `${styles.button} ${styles.buttonText} ${className} ${styles.buttonDisabled}`
    : `${styles.button} ${styles.buttonText} ${className}`

  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      className={clsName}
      onClick={onClick}
      disabled={disabled}
      {...other}
    >
      {iconName && (
        <Icon
          name={iconName}
          group={SVGGroup.Icons}
          width={iconWidth}
          height={iconHeight}
        />
      )}
      {children}
      {isLargeBtn && text}
    </button>
  )
}
